(function () {
    'use strict';

    angular
        .module('app.departments')
        .run(appRun);

    appRun.$inject = ['routerHelper', 'opsIncludeVersion'];
    /* @ngInject */
    function appRun(routerHelper, opsIncludeVersion) {
        routerHelper.configureStates(getStates(opsIncludeVersion));
    }

    function getStates(opsIncludeVersion) {
        return [
              {
                  state: 'departments',
                  config: {
                      abstract: true,
                      url: '/departments',
                      template: '<ui-view/>',
                      settings: {
                          authMode: 1
                      },
                      resolve: {
                          authenticationRequired: ['userService', function (userService) {
                              if (userService.userType() == "0") {
                                  throw { name: "NotAdmin" };
                              }
                          }]
                      }
                  }
              },
            {
                state: 'departments.list',
                config: {
                    url: '/list',
                    templateUrl: 'app/departments/list.html?v=' + opsIncludeVersion,
                    controller: 'DepartmentsListController',
                    controllerAs: 'vm',
                    title: 'Departments'
                }
            },
            {
             state: 'departments.details',
             config: {
                 url: '/detail/:id',
                 templateUrl: 'app/departments/details.html?v=' + opsIncludeVersion,
                 controller: 'DepartmentDetailController',
                 controllerAs: 'vm',
                 title: 'Department',
                 settings: {}
             }
            }
          
        ];
    }
})();
